module.exports = __webpack_public_path__ + "static/media/calendar-check-inactive.84442c50.svg";